import "./_section.scss";

function Title({
  title,
  complement = "",
  ...props
}: {
  title: string;
  complement?: string;
} & React.HTMLAttributes<HTMLHeadingElement>): JSX.Element {
  return (
    <h1 className="title" {...props}>
      {title} <span>{complement}</span>
    </h1>
  );
}

export default Title;
